<style lang="css">
.flex-col {
  display: flex;
  flex-direction: column;
}
.p-4 {
  padding: 1rem !important;
}
.login-btn {
  margin-top: 0.5rem;
  font-weight: bold;
  font-size: 1.25rem;
  border-radius: 1.5rem;
}
.login-btn:hover {
  transform: scale(1.25);
  transition-property: all;
  transition-duration: 1s;
  transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}
.neuro {
  box-shadow: 0 15px 35px rgba(54, 96, 170, 0.12),
    0 5px 15px rgba(0, 0, 0, 0.05);
}
.neuro-card {
  margin-top: 3rem;
  background-color: #ffffff99;
  border-radius: 2rem;
}
.neuro-img {
  box-shadow: #aaaaaa 0.25rem 0.25rem 0.5rem,
    inset #ffffff -0.25rem -0.25rem 0.5rem;
  padding: 1rem;
  margin: 1rem;
  border-radius: 2rem;
}
.neuro-input {
  text-align: center;
  background-color: #ececec;
  padding: 1rem;
  margin: 0.5rem 0.1rem 0 0;
  font-weight: 600;
  font-size: 1.5rem;
  color: #505050;
  text-transform: uppercase;
  border-radius: 1.5rem;
  border: none;
  box-shadow: inset #aaaaaa 0.125rem 0.125rem 0.5rem,
    inset #ffffff -0.35rem -0.35rem 0.5rem;
}
</style>
<template>
  <!-- Modal Structure -->
  <div id="modal-reset-password-request" class="modal">
    <form @submit.prevent="sendPasswordResetEmail()" v-if="!authCode">
      <div class="modal-content">
        <h4>Ingresa tu correo electrónico</h4>
        <div class="row">
          <div class="col s12">
            <blockquote>
              Para restablecer tu contraseña, ingresa el correo electrónico
              asociado a tu cuenta y te enviaremos un enlace para restablecerla.
            </blockquote>
          </div>
        </div>
        <div class="row">
          <div class="col s12 input-field">
            <input
              autocomplete="username"
              required
              id="email_forgot"
              type="email"
              class="validate"
              v-model="forgotten_account_email"
            />
            <label class="active" for="email_forgot">Correo Electrónico</label>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Cerrar</a
        >
        <button
          type="submit"
          style="border-radius: 1.5rem"
          class="btn blue waves-effect waves-light"
        >
          Enviar enlace
        </button>
      </div>
    </form>
    <form @submit.prevent="changePassword()" v-else>
      <div class="modal-content">
        <h4>Restablecer Contraseña</h4>
        <div class="row">
          <div class="col s12">
            <div class="input-field">
              <input
                autocomplete="new-password"
                required
                pattern="[A-Z]{1,}[a-z]{1,}[0-9]{1,}[\w\W]{1,}"
                id="password_forgot"
                type="password"
                class="validate"
                v-model="new_password"
              />
              <label class="active" for="password_forgot"
                >Nueva Contraseña</label
              >
            </div>
          </div>
          <div class="col s12">
            <div class="input-field">
              <input
                autocomplete="new-password"
                required
                pattern="[A-Z]{1,}[a-z]{1,}[0-9]{1,}[\w\W]{1,}"
                id="password_confirm"
                type="password"
                class="validate"
                v-model="new_password_confirm"
              />
              <label class="active" for="password_confirm"
                >Confirmar Nueva Contraseña</label
              >
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Cerrar</a
        >
        <button
          type="submit"
          style="border-radius: 1.5rem"
          class="btn blue waves-effect waves-light"
        >
          Cambiar Contraseña
        </button>
      </div>
    </form>
  </div>

  <div class="container center">
    <div class="row container" style="">
      <div style="" class="card neuro-card neuro col s12 m8 offset-m2">
        <div class="card-content">
          <div
            class="card-title"
            style="
              font-size: 2rem;
              font-weight: bold;
              padding: 1rem;
              color: #3660aa;
            "
          >
            SOLTAR TRACKER
            <br />
            <small style="font-size: 1.25rem; color: #505050; font-weight: 600">
              Rastreador de paquetes.
            </small>
          </div>
          <img
            style="padding-bottom: 0.5rem; width: 25%"
            src="../../assets/tucan.png"
            class="responsive-img neuro-img"
            alt=""
          />

          <form @submit="login($event)" id="login-form">
            <div class="card-content center">
              <div class="row">
                <div class="col s12 flex-col p-4">
                  <label
                    class="browser-default flow-text black-text"
                    for="email"
                    >Correo Electrónico</label
                  >
                  <input
                    class="browser-default neuro-input"
                    placeholder="alguien@solotarjetas.com.mx"
                    required
                    name="email"
                    id="email"
                    v-model="email"
                    type="email"
                  />
                </div>
                <div class="col s12 flex-col p-4">
                  <label
                    class="browser-default flow-text black-text"
                    for="password"
                    >Contraseña</label
                  >
                  <input
                    class="browser-default neuro-input"
                    style="letter-spacing: 0.5rem"
                    placeholder="secreto"
                    required
                    name="password"
                    id="password"
                    v-model="password"
                    type="password"
                  />
                </div>
                <!-- FORGOT PASSWORD?  -->
                <div class="col s12 right-align">
                  <a
                    class="waves-effect flow-text waves-light modal-trigger"
                    href="#modal-reset-password-request"
                    >¿Olvidaste tu contraseña?</a
                  >
                </div>
              </div>
              <div class="card-action center">
                <button
                  v-if="!loading"
                  type="submit"
                  class="login-btn btn blue btn-large"
                >
                  iniciar sesión
                </button>
                <div v-else class="lds-ripple">
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <footer class="center page-footer white black-text">
    <div class="container">
      <div class="row">
        <div class="col">
          <ul style="display: inline-flex">
            <li class="redes">
              <a
                href="https://www.facebook.com/Caveri.mx"
                target="_blank"
                rel="noopener noreferrer"
                ><i class="mdi mdi-36px mdi-facebook"></i
              ></a>
            </li>
            <li class="redes">
              <a
                class=""
                href="https://twitter.com/CaveriMx"
                target="_blank"
                rel="noopener noreferrer"
                ><i class="mdi mdi-36px mdi-twitter"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="black-text footer-copyright">
      <div class="container">
        © 2021-2026 SOLTAR IMPRESORES S.A. DE C.V.
        <a class="right" href="#!">Ayuda</a>
      </div>
    </div>
  </footer>
</template>

<script>
import M from "materialize-css";
import firebase from "firebase/app";

export default {
  created() {
    let $this = this;
    const actionCode = new URLSearchParams(window.location.search).get('oobCode');
    setTimeout(() => {
      var elems = document.querySelectorAll(".fixed-action-btn");
      M.FloatingActionButton.init(elems, { direction: "top" });
      elems = document.querySelector("#modal-reset-password-request");
      $this.modal_forgotten_password = M.Modal.init(elems, { opacity: 0.5, inDuration: 300, outDuration: 200 });
      if (actionCode) {
        $this.modal_forgotten_password.open();
      }
    }, 0);
    
  },
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = window.user = user;

      if (user) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            let claims = idTokenResult.claims;
            this.permisos = claims.permisos;
            location.href = "/";
            this.$forceUpdate();
          })
          .catch((error) => {
            console.log(error);
          });

        
      }
    });
  },

  data() {
    return {
      user: undefined,
      loading: false,
      permisos: {},
      email: undefined,
      password: undefined,
      forgotten_account_email: undefined,
      modal_forgotten_password: undefined,
      errores: {
        "auth/wrong-password":
          "La contraseña es inválida o el usuario no tiene contraseña asignada.",
        "auth/user-not-found":
          "No hay una cuenta de usuario correspondiente a este identificador. El usuario pudo haber sido borrado.",
      },
    };
  },
  methods: {
    changePassword() {
      if (this.new_password != this.new_password_confirm) {
        M.toast({ html: "Las contraseñas no coinciden.", classes: "red" });
        return;
      }
      firebase
        .auth()
        .currentUser.updatePassword(this.new_password)
        .then(() => {
          M.toast({ html: "Contraseña actualizada exitosamente." });
          let modal = M.Modal.getInstance(document.querySelector("#modal1"));
          modal.close();
        })
        .catch((err) => {
          console.log(err);
          M.toast({ html: err.message, classes: "red" });
        });
    },
    sendPasswordResetEmail() {
      const actionCodeSettings = {
        // The URL to redirect to after password reset.
        url: window.location.origin + "/login",
        handleCodeInApp: false, // Set to true if handling the reset entirely in-app
      };

      firebase
        .auth()
        .sendPasswordResetEmail(this.forgotten_account_email, actionCodeSettings)
        .then(() => {
          M.toast({ html: "Correo de restablecimiento enviado." });
          this.forgotten_account_email = undefined;
          
          this.modal_forgotten_password.close();
        })
        .catch((err) => {
          console.log(err);
          let msg;
          switch (err.code) {
            case "auth/invalid-credential":
              msg = "Las credenciales proporcionadas no son válidas.";
              break;
            case "auth/user-not-found":
              msg = "El usuario especificado no existe en nuestros registros.";
              break;
            default:
              msg = "Un error desconocido ha ocurrido." + err.message;
          }
          M.toast({
            html: msg,
            classes: "red",
          });
        });
    },
    setPersistenceAndLogin() {
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => {
          // Existing and future Auth states are now persisted in the current
          // session only. Closing the window would clear any existing state even
          // if a user forgets to sign out.
          // ...
          // New sign-in will be persisted with session persistence.
          return this.signInWithEmailAndPassword();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    signInWithEmailAndPassword() {
      try {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then((result) => {
            let usr = result.user;
            console.log(usr);
            if (usr) {
              M.toast({ html: "Logueado como " + usr.displayName });
              if (this.$route.query.redirect){
                this.$router.go(this.$route.query.redirect);
              }
              else{
                this.$router.go("home");
              }
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
            let msg;
            switch (err.code) {
              case "auth/user-not-found":
                msg =
                  "El usuario especificado no existe en nuestros registros.";

                break;
              case "auth/wrong-password":
                msg = "La contraseña es inválida.";
                break;
              case "auth/argument-error":
                msg = "Aseg[urate de haber llando los campos solicitados.";
                break;

              default:
                msg = "Un error desconocido ha ocurrido." + err.message;
            }
            M.toast({
              html: msg,
              classes: "red",
            });
          });
      } catch (err) {
        console.log(err);
        M.toast({ html: err, classes: "red" });
      }
    },
    login($e) {
      this.loading = true;
      $e.preventDefault();
      this.setPersistenceAndLogin();
    },
  },
};
</script>
